import React from "react";
import { Modal, ModalBody } from "reactstrap";

interface DeleteModalProps {
  logout?: boolean;
  editarModal?: boolean;
  addModal?: boolean;
  show?: boolean;
  onDeleteClick?: () => void;
  onCloseClick?: () => void;
  recordId?: string;
}

const DeleteModal: React.FC<DeleteModalProps> = ({
  logout,
  editarModal,
  addModal,
  show,
  onDeleteClick,
  onCloseClick,
  recordId,
}) => {
  return (
    <Modal fade={true} isOpen={show} toggle={onCloseClick} centered={true}>
      <ModalBody className="py-3 px-5">
        <div className="mt-2 text-center">
          {logout ? (
            <i className="ri-logout-box-line display-5 text-danger"></i>
          ) : editarModal ? (
            <i className="ri-thumb-up-line display-5 text-primary"></i>
          ) : addModal ? (
            <i className="ri-user-add-line display-5 text-warning"></i>
          ) : null}
          <div className="mt-4 pt-2 fs-15 mx-4 mx-sm-5">
            <p className="text-muted mx-4 mb-0">
              {logout
                ? "Desejar fazer o logout do sistema"
                : editarModal
                ? "Tem certeza de que deseja atender esta empresa"
                : addModal
                ? "Esta empresa está liberado para entrar na fila "
                : null}{" "}
              <b>{recordId ? recordId : ""}</b> ?
            </p>
          </div>
        </div>
        <div className="d-flex gap-2 justify-content-center mt-4 mb-2">
          <button
            type="button"
            className="btn w-sm btn-light"
            data-bs-dismiss="modal"
            onClick={onCloseClick}
          >
            Fechar
          </button>
          {editarModal ? (
            <button
              type="button"
              className="btn w-sm btn-primary"
              id="delete-record"
              onClick={onDeleteClick}
            >
              Atender
            </button>
          ) : addModal ? (
            <button
              type="button"
              className="btn w-sm btn-warning"
              id="delete-record"
              onClick={onDeleteClick}
            >
              Liberar
            </button>
          ) : (
            <button
              type="button"
              className="btn w-sm btn-danger"
              id="delete-record"
              onClick={onDeleteClick}
            >
              {logout ? "Logout" : editarModal ? "Desativar" : "Deletar"}
            </button>
          )}
        </div>
      </ModalBody>
    </Modal>
  ) as unknown as JSX.Element;
};

export default DeleteModal;
